import { FeatureFlags } from '@socrata/platform/feature-flags';

/**
 * Whether users can pin columns in table visualizations.
 */
export function isColumnPinningEnabled(): boolean {
  return FeatureFlags.valueOrDefault('enable_pinning_columns_in_tables', false);
}
